import React from 'react';

import classes from './Burger.css';
import BurgerIngredient from './BurgerIngredient/BurgerIngredient';

const burger = (props) => {
    let transformedIngredients = Object.keys(props.ingredients)
        .map(igKey => {
            return [...Array(props.ingredients[igKey])].map((_, i) => {
                return <BurgerIngredient key={igKey + i} type={igKey} />;
            });
        })
        .reduce((arr, el) => {
            return arr.concat(el)
        }, []);
    if (transformedIngredients.length === 0) {
        transformedIngredients = (
            <div>
                <h3>Toane Privacy Policy & Support Information</h3>
                <p><span>App Creator:</span> KJ Garrett</p>
                <p><span>Contact for Support at:</span> Kijana.Garrett@gmail.com</p>
                <p><span>Data Collection:</span> In terms of data collection, Toane leverages your Spotify Premium account in order to play music.
                We use your Spotfy Username for the name of the file that tracks your musical preferences and stores them in a secure directory. Other than
                your Spotify username, we store no personal data about you or any of your Spotify account information. Musical preferences are subdivided into similar genres
                and each genre group has a ranking based on your usage and interaction with the App. Your current mood is also stored in our database, but no other information outside of your
                Spotify username and your Toane music preferences are utilized within the application.
            </p>
                <p>The current conversation going on in the room is used for sentiment analysis to provide a given genre of music to you, the user. 
                This text is sent to our server and then to Google NLP API for sentiment analysis. After this, the text from the conversation is deleted and the scores are used in the music determining algorithm.
            </p>
                <p>Future versions of this application, will also consist of a similar approach to data storage and privacy. These consideration are of the
                    utmost importance and will not be neglected in future versions.
            </p>
                <p><span>Date:</span> March 19, 2019</p>
            </div>);
    }
    return (
        <div className={classes.Burger}>
            <BurgerIngredient type="bread-top" />
            {transformedIngredients}
            <BurgerIngredient type="bread-bottom" />
        </div>
    );
};

export default burger;